import { render, staticRenderFns } from "./Ajuste.vue?vue&type=template&id=53ca81d6&scoped=true"
import script from "./Ajuste.vue?vue&type=script&lang=js"
export * from "./Ajuste.vue?vue&type=script&lang=js"
import style0 from "./Ajuste.vue?vue&type=style&index=0&id=53ca81d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca81d6",
  null
  
)

export default component.exports